import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Alert } from '../alerts.interface';

@Injectable({ providedIn: 'root' })
export class GlobalAlertState {
  alertChange$ = new Subject<Alert>();

  setAlert(alert: Alert) {
    this.alertChange$.next(alert);
  }
}
